import { Box, Typography, Button, Divider } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import { FeaturesList, FeaturesListItem } from "./PremiumAccountCard";
import { motion } from "framer-motion";
import styled from "styled-components";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import BasicAccountDetails from "./BasicAccountDetails";

type BasicAccountCardProps = {
  handleAnimate: () => void;
  showBasisForm: boolean;
};

const BasisAccountCard = ({
  handleAnimate,
  showBasisForm,
}: BasicAccountCardProps) => {
  const { t } = useTranslation();
  return (
    <StyledCard
      id="target"
      $showBasisForm={showBasisForm}
      as={motion.div}
      whileHover={showBasisForm ? {} : { scale: 1.02 }}
      $isMobile={isMobile}
      animate={{ x: 0 }}
    >
      <BasicAccountDetails />
      {!showBasisForm && (
        <Button
          variant="outlined"
          sx={{
            borderRadius: 5,
            width: "100%",
            marginTop: { xs: 10, sm: 2, md: 2, lg: 2, xl: 2 },
          }}
          onClick={handleAnimate}
        >
          {t("profile.signup")}
        </Button>
      )}
    </StyledCard>
  );
};

const StyledCard = styled.div<{
  $showBasisForm: boolean;
  id: string;
  children: React.ReactNode;
  $isMobile: boolean;
}>`
  padding: 30px;
  width: ${({ $isMobile }) => ($isMobile ? "100%" : "")};
  border: ${({ $showBasisForm }) =>
    $showBasisForm ? "none" : "2px solid #e8e8e8"};
  border-radius: 20px;
  background: ${({ $showBasisForm }) => ($showBasisForm ? "none" : "#fff")};
`;

export default BasisAccountCard;
